export const masks: {
  [key: string]: { searchValue: RegExp; replaceValue: string };
} = {
  phone: {
    searchValue: /(\d{2})(\d{4})(\d{0,4})/,
    replaceValue: "($1) $2-$3",
  },
  celphone: {
    searchValue: /(\d{2})(\d{5})(\d{0,4})/,
    replaceValue: "($1) $2-$3",
  },
  cpf: {
    searchValue: /(\d{3})(\d{3})(\d{3})(\d{2})/,
    replaceValue: "$1.$2.$3-$4",
  },
  cep: {
    searchValue: /(\d{5})(\d{3})/,
    replaceValue: "$1-$2",
  },
  card_number: {
    searchValue: /(\d{4})(\d{4})(\d{4})(\d{4})/,
    replaceValue: "$1 $2 $3 $4",
  },
};
